import { LogLevel } from '../models/log-level.enum';
import { LogWriter } from '../writers/log-writer';
import { Injectable } from '@angular/core';

/**
 * extend this class in your solution and register the provider
 *
 * @example
 * export class MyLogConfigService extends LogConfigService {
 *  getLogLevel(): LogLevel {
 *     return <your log level of choice>
 *  }
 *  getLogWriters(): LogWriter[] {
 *     return <your array of logWriters here>
 *  }
 * }
 *
 * add the following to the providers tag of the module
 * { provide: LogConfigService, useFactory: () => new MyLogConfigService() }
 */
@Injectable()
export abstract class LogConfigService {
    public abstract getLogLevel(): LogLevel;
    public abstract getLogWriters(): LogWriter[];
}
